import { isHtm } from "./const";
export const normalLanguageArr = [
  {
    label: 'English',
    value: 'en',
  },
  {
    label: '日本語',
    value: 'ja'
  },
  {
    label: '한국어',
    value: 'ko',
  },
  {
    label: 'ไทย',
    value: 'th',
  },
];

export const htmLanguageArr = [
  {
    label: '繁中',
    value: 'zh',
  },
]

export const languageArr = isHtm ? htmLanguageArr: normalLanguageArr;
export function setLanguageDialog(event: Event) {
  event.stopPropagation();
  window.$('.nv_list').slideToggle();
}